import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetUserVerifiedPhonesQuery,
  GetUserVerifiedPhonesQueryVariables,
} from "./PhoneVerification.generated";

export const GET_USER_VERIFIED_PHONES: TypedDocumentNode<
  GetUserVerifiedPhonesQuery,
  GetUserVerifiedPhonesQueryVariables
> = gql`
  query GetUserVerifiedPhones {
    verifiedPhoneNumbers {
      verifiedPhoneNumberUuid
      phoneNumber
      twilioVerificationStatus
      createdAt
      isDeleted
      teamUuid
      team {
        uuid
        name
      }
      user {
        uuid
        firstName
        lastName
      }
      isOwnedByCurrentUser
    }
  }
`;
